import axios from "@/libs/api.request";
import { getToken } from "@/libs/util";

export const getList = (data) => {
  return axios.request({
    url: "/warehouse/shipments/getHeadWayAwb",
    method: "post",
    data,
  });
};

// 关联中港单
export const setBindPackage = (data) => {
  return axios.request({
    url: "/warehouse/shipments/setBindPackage",
    method: "post",
    data,
  });
};
